import { Resources } from '@shared/localizations/Resources';
import { SLTPTrigger } from '../SlTpTrigger';
import { OperationType } from '../Trading/OperationType';
export function formatOperationType(operationType, isShortLong) {
    if (operationType === OperationType.Buy) {
        return isShortLong
            ? Resources.getResource('general.trading.position.Buy')
            : Resources.getResource('general.trading.Buy');
    }
    else {
        return isShortLong
            ? Resources.getResource('general.trading.position.Sell')
            : Resources.getResource('general.trading.Sell');
    }
}
export function formatLeverage(leverageValue, inShortFormat) {
    if (!isValidNumber(leverageValue)) {
        return '';
    }
    return inShortFormat ? leverageValue.toString() : leverageValue + ' x';
}
export function formatSLTPTrigger(trigger) {
    if (isValidNumber(trigger)) {
        return SLTPTrigger.ConvertBidAskRawValueToStr(trigger);
    }
    else {
        return '';
    }
}
